import { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core";

export type CellActionProps = {
  title: string | ReactNode;
  action: () => void;
};

export const CellAction = ({ action, title }: CellActionProps) => {
  const classes = useStyles();
  return (
    <div className={classes.actionText} onClick={action} role="button">
      {title}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionText: {
      display: "inline",
      cursor: "pointer",
      fontSize: 12,
      fontWeight: "bold",
      lineHeight: 1.58,
      letterSpacing: 1,
      textAlign: "right",
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(1.25),
      fontFamily: theme.typography.fontFamily,
    },
  }),
);
